<template>
  <ion-card>
    <ion-card-content>
      <ion-item>
        <ion-label position="floating">
          Name
        </ion-label>
        <ion-input-vue v-model="deviceGroup.name" />
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Group type
        </ion-label>
        <ion-select-vue 
          v-model="deviceGroup.type"
          interface="popover"
        >
          <ion-select-option 
            v-for="(type, key) in deviceGroupTypes" 
            :key="key"
            :value="type"
          >
            {{ getTypeName(type) }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Slab type
        </ion-label>
        <ion-select-vue 
          v-model="deviceGroup.slabType"
          interface="popover"
        >
          <ion-select-option 
            v-for="(name, key) in slabTypeNames"
            :key="key"
            :value="key"
          >
            {{ name }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Description
        </ion-label>
        <ion-textarea-vue v-model="deviceGroup.description" />
      </ion-item>
    </ion-card-content>

    <ion-card-footer>
      <ion-button
        expand="full"
        class="ion-margin-top"
        @click="save"
      >
        <ion-spinner
          v-if="busy"
          color="me"
        />
        <ion-text
          v-else
          color="light"
        >
          Save
        </ion-text>
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import _ from 'lodash'

import { IonInputVue, IonTextareaVue, IonSelectVue } from '@modus/ionic-vue'
import deviceGroupTypes from './deviceGroupTypes'
import { slabTypeNames } from './slabTypes'

import router from '../../router'
import store from '../../state'
import { modalController } from '@ionic/core'

export default {
  components: {
    IonInputVue,
    IonTextareaVue,
    IonSelectVue
  },
  props: {
    deviceGroup: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deviceGroupTypes,
      slabTypeNames,
      busy: false
    }
  },
  methods: {
    getTypeName(type) {
      return _.startCase(type.toLowerCase())
    },
    save() {
      const serialNumber = router.currentRoute.params.serialNumber
      const deviceGroup = this.deviceGroup

      this.busy = true

      store.dispatch('updateDeviceGroup', { serialNumber, deviceGroup })
        .finally(() => this.busy = false)  
        .finally(() => modalController.dismiss())
    }
  }
}
</script>

<style scoped>
ion-card {
  margin:0;
}
</style>

<style>
.update-device-group-modal .modal-wrapper {
  background:none;
}
</style>